import React, { useCallback, useEffect, useMemo, useState } from 'react';
import * as styles from './top-talent-category-dynamics.module.scss';
import { calendar_empty } from '../../../../assets/img';
import DataFromModal, { DATA_FROM_TYPE, DATE_FILTER_TYPE } from '../DataFromModal/DataFromModal';
import { cloneDeep, isArray, isEmpty } from 'lodash';
import { TA_TENURE_TABS } from '../../talent-analytics.constant';
import { talentAnalyticApi } from '../../../../services/talentAnalyticApi';
import { Spin } from 'antd';

const TopTalentCategoryDynamics = (props) => {
  const { tabFilters, currentTab, masterFilter, roleId, setUpdatedFilters, updatedFilters } = props;
  const [showDataFrom, setShowDataFrom] = useState(false);
  const [dataFrom, setDataFrom] = useState({
    type: DATA_FROM_TYPE.THIS_MONTH,
    month: DATA_FROM_TYPE.THIS_MONTH,
    year: null,
    range: [],
  });
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(false);

  const convertDdMmYyyyToIso = (dateString) => {
    if (!dateString) return;

    const [day, month, year] = dateString.split('/');
    const dateObj = new Date(year, month - 1, day);
    return dateObj.toISOString();
  };

  const getDataFromLabel = useMemo(() => {
    let tempLabel = '';
    switch (dataFrom?.type) {
      case DATA_FROM_TYPE.CUSTOM_DATE_RANGE:
        tempLabel = isArray(dataFrom?.range) ? `${dataFrom?.range[0]} - ${dataFrom?.range[1]}` : '';
        break;
      case DATA_FROM_TYPE.THIS_MONTH:
        tempLabel = DATA_FROM_TYPE.THIS_MONTH;
        break;
      case DATA_FROM_TYPE.THIS_YEAR:
        tempLabel = DATA_FROM_TYPE.THIS_YEAR;
        break;
      case DATA_FROM_TYPE.CUSTOM_MONTH:
        tempLabel = !isNaN(dataFrom?.month) ? `Last ${dataFrom?.month} Months` : '';
        break;
      case DATA_FROM_TYPE.CUSTOM_YEAR:
        tempLabel = !isNaN(dataFrom?.year) ? `Last ${dataFrom?.year} Years` : '';
        break;
      default:
        break;
    }

    return tempLabel;
  }, [dataFrom]);

  const getPayload = useMemo(() => {
    let tempFromVal = '';
    let tempTypeVal = '';
    switch (dataFrom?.type) {
      case DATA_FROM_TYPE.CUSTOM_DATE_RANGE:
        tempFromVal = isArray(dataFrom?.range) ? convertDdMmYyyyToIso(dataFrom.range[0]) : null;
        tempTypeVal = DATE_FILTER_TYPE.DATE_RANGE;
        break;
      case DATA_FROM_TYPE.THIS_MONTH:
      case DATA_FROM_TYPE.THIS_YEAR:
        tempFromVal = 0;
        tempTypeVal = DATA_FROM_TYPE.THIS_MONTH === dataFrom?.type ? DATE_FILTER_TYPE.MONTH : DATE_FILTER_TYPE.YEAR;
        break;
      case DATA_FROM_TYPE.CUSTOM_MONTH:
        tempFromVal = dataFrom?.month || null;
        tempTypeVal = DATE_FILTER_TYPE.MONTH;
        break;
      case DATA_FROM_TYPE.CUSTOM_YEAR:
        tempFromVal = dataFrom?.year || null;
        tempTypeVal = DATE_FILTER_TYPE.YEAR;
        break;
      default:
        break;
    }

    return {
      masterFilter,
      filter: {
        type: tempTypeVal,
        from: tempFromVal,
        to: [DATA_FROM_TYPE.CUSTOM_DATE_RANGE].includes(dataFrom?.type) && isArray(dataFrom?.range) ? convertDdMmYyyyToIso(dataFrom?.range[1]) : null,
      },
    };
  }, [dataFrom, masterFilter]);

  const fetchTopTalentCategorisation = useCallback(async () => {
    try {
      setLoading(true);
      const res = await talentAnalyticApi.fetchTopTalentCategoryDynamics(getPayload, roleId);
      if (res.status === 200) {
        setDataSource(res.data.result);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setUpdatedFilters((prev) => {
        const cloneState = cloneDeep(prev);
        cloneState[3] = false;
        return cloneState;
      });
    }
  }, [tabFilters[TA_TENURE_TABS[3]], roleId, masterFilter, getPayload]);

  useEffect(() => {
    if (currentTab !== TA_TENURE_TABS[3] || !updatedFilters[3]) return;
    fetchTopTalentCategorisation();
  }, [currentTab, updatedFilters[3], roleId, getPayload, fetchTopTalentCategorisation]);

  return (
    <>
      <div className={styles.container}>
        <div className={styles.dataFrom} onClick={() => setShowDataFrom(true)}>
          <img className={styles.dataFromIcon} src={calendar_empty} alt="" />
          <div className={styles.dataFromLabel}>
            Showing data from:
            <span className={styles.dataFromVal}>{getDataFromLabel}</span>
          </div>
        </div>
        <Spin spinning={loading}>
          <div className={styles.cardList}>
            {!isEmpty(dataSource) &&
              dataSource.map((item, index) => (
                <div className={styles.cardListWrap} key={index}>
                  <div className={styles.cardListTitle}>
                    <span className={styles.cardListSubTitle}> Top Talent Category {item.label}</span>
                  </div>
                  <div className={styles.cardItemWrap}>
                    {item.children.map((c, cIndex) => (
                      <div className={styles.cardListItem} key={cIndex}>
                        <div className={styles.total}>{c.total}</div>
                        <button
                          type="button"
                          className={styles.viewBtn}
                          disabled={Number(c.total) === 0}
                          style={Number(c.total) === 0 ? { cursor: 'no-drop', opacity: 0.7 } : null}
                        >
                          View Report
                        </button>
                        <div className={styles.desc}>{c.label}</div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
          </div>
        </Spin>
      </div>
      <DataFromModal
        showModal={showDataFrom}
        setShowModal={setShowDataFrom}
        setDataFrom={setDataFrom}
        dataFrom={dataFrom}
        setUpdatedFilters={setUpdatedFilters}
      />
    </>
  );
};

export default TopTalentCategoryDynamics;
